<div class="landing">
    <div class="banner">
        <div class="banner__banner-content">
            <h2 class="banner__banner-content__title">Invest in your
                education,<br> invest in
                your future</h2>
            <a routerLink="/apply" class="banner__banner-content__cta-button"
                aria-label="Apply for Education Loan">Apply
                now</a>
        </div>
    </div>
    <div class="landing-content">
        <div class="landing-content__section">

            <p class="landing-content__section__description">With an Absa Education Loan, you can cover your study fees
                and concentrate
                on what matters most, achieving your academic goals.</p>
            <h4 class="landing-content__section__title">
                Why choose an Absa Education Loan</h4>
        </div>

        <div class="landing-content__section1">
            <div class="landing-content__section1__box">
                <img src="assets/icons/wallet.svg" class="icon" />
                <h4 class="landing-content__section1__box__title">Cover your full tuition</h4>
                <p class="landing-content__section1__box__description">You can get up to R 350 000 to
                    cover your tuition and study related costs</p>
            </div>
            <div class="landing-content__section1__box">
                <img src="assets/icons/interest.svg" class="icon" />
                <h4 class="landing-content__section1__box__title">Personalised interest rate</h4>
                <p class="landing-content__section1__box__description">Your interest rate is based on your
                    profile and credit history</p>
            </div>
            <div class="landing-content__section1__box">
                <img src="assets/icons/card.svg" class="icon" />
                <h4 class="landing-content__section1__box__title">Flexible repayments</h4>
                <p class="landing-content__section1__box__description">Pay back your loan in monthly
                    instalments that suit your budget</p>
            </div>

        </div>

        <!-- <div class="landing-content__section2">
            <h3 class="landing-content__section2__title">Who can apply</h3>
            <h4>You can apply for an Absa Education Loan if you:</h4>
            <ul class="landing-content__section2__list">
                <li class="landing-content__section2__list__item">Are 18 years or older</li>
                <li class="landing-content__section2__list__item">Are a South African citizen or permanent resident</li>
                <li class="landing-content__section2__list__item">Earn a regular monthly income of at least R2 000 per
                    month</li>
                <li class="landing-content__section2__list__item">Have a bank account into which your income is paid
                </li>
            </ul>
        </div>

        <div class="landing-content__section3">
            <h3 class="landing-content__section3__title">Documents needed to apply</h3>
            <ul class="landing-content__section3__list">
                <li class="landing-content__section3__list__item">South African ID book or card</li>
                <li class="landing-content__section3__list__item">Last three months payslips or bank statements</li>

            </ul>
        </div>

        <div class="landing-content__section4">
            <h3 class="landing-content__section4__title">Ready to apply?</h3>
            <a routerLink="/apply" class="landing-content__section4__cta-button"
                aria-label="Apply for Education Loan">Apply
                now</a>
        </div> -->
        <div class="landing-accordion">

            <!-- Who can apply -->
            <div class="landing-accordion__item">
                <button class="landing-accordion__header" (click)="toggleAccordion(0)"
                    [attr.aria-expanded]="openIndex === 0">

                    <span>Who can apply</span>
                    <img src="assets/icons/arrow.svg" class="landing-accordion__icon" [class.open]="openIndex === 0"
                        alt="Arrow icon" />
                </button>

                <div class="landing-accordion__content" #content>
                    <ul>
                        <li>Are 18 years or older</li>
                        <li>Are a South African citizen or permanent resident</li>
                        <li>Earn a regular monthly income of at least R2 000 per month</li>
                        <li>Have a bank account into which your income is paid</li>
                    </ul>
                </div>
            </div>

            <!-- Documents needed -->
            <div class="landing-accordion__item">
                <button class="landing-accordion__header" (click)="toggleAccordion(1)"
                    [attr.aria-expanded]="openIndex === 1">

                    <span>Documents needed to apply</span>
                    <img src="assets/icons/arrow.svg" class="landing-accordion__icon" [class.open]="openIndex === 1"
                        alt="Arrow icon" />
                </button>

                <div class="landing-accordion__content" #content>
                    <ul>
                        <li>South African ID book or card</li>
                        <li>Last three months payslips or bank statements</li>
                    </ul>
                </div>
            </div>

            <!-- How to apply -->
            <div class="landing-accordion__item">
                <button class="landing-accordion__header" (click)="toggleAccordion(2)"
                    [attr.aria-expanded]="openIndex === 2">

                    <span>How to apply</span>
                    <img src="assets/icons/arrow.svg" class="landing-accordion__icon" [class.open]="openIndex === 2"
                        alt="Arrow icon" />
                </button>

                <div class="landing-accordion__content" #content>
                    <p>Click
                        <a routerLink="/apply" class="landing-accordion__link" aria-label="Apply for Education Loan">
                            here
                        </a> to apply online
                    </p>
                </div>
            </div>

        </div>

        <div class="landing-content__section5">
            <h3 class="landing-content__section5__title">Contact Details</h3>
            <p>Need help?</p>
            <ul class="landing-content__section5__list">
                <li class="landing-content__section5__list__item">Call us on 0860 100 372</li>
                <!-- <a
                        href="mailto:info@absaeducation.co.za"
                        style="text-decoration: none; color: #AF144B;;">info@absaeducation.co.za</a></li> -->
                <li class="landing-content__section5__list__item">Visit your nearest Absa branch</li>
            </ul>
        </div>
    </div>
</div>